/**
 * @description: Vuex
 */

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import * as types from './types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isShowMenuList: false, // 是否显示菜单
    menunew: [], // 菜单
    selectedMenu: {}, // 选中菜单
    selectedSidebar: {}, // 选中侧边栏-------新版放弃，待删----------
    selectTabs: [], // 已经选中 tab 页数据
    version: '', // 版本
    version_name: '', // 版本名称
    versionurl: '', // 版本地址
    usermobile: '', // 账号
    username: '', // 昵称
    mercid: '', // 商家id
    privinfo: {}, // 其他信息

    token: '', // 旧版，验证登录-------新版放弃，待删----------
    shop_report_default_time: [], // 商家报表时间设置
    report_token: '', // 报表系统token
    report_base_url: '', // 报表系统域名
    business_model: '',
    tx_ak: '',
    aiModule: false, // 添加 AI 模块显示状态
  },
  mutations: {
    [types.LOGIN]: (state, data) => {
      state.isShowMenuList = true
      state.version = data.version
      state.versionurl = data.versionurl
      state.version_name = data.version_name
      state.usermobile = data.usermobile
      state.username = data.username
      state.mercid = data.mercid

      state.token = data.token
      state.shop_report_default_time = data.shop_report_default_time
      state.business_model = data.business_model
      state.tx_ak = data.tx_ak
      state.privinfo = data.privinfo
    },
    [types.LOGOUT]: (state) => {
      state.isShowMenuList = false
      state.menunew = []
      state.selectedMenu = {}
      state.selectTabs = []
      state.selectedSidebar = {}
      state.version = ''
      state.versionurl = ''
      state.version_name = ''
      state.usermobile = ''
      state.username = ''
      state.mercid = ''
      state.privinfo = {}

      state.token = ''
    },
    [types.INDEX]: (state) => {
      state.selectedMenu = {}
      state.selectTabs = []
      state.selectedSidebar = {}
    },
    [types.MENUNEW]: (state, data) => {
      state.menunew = data;
    },
    [types.SELECTEDMENU]: (state, data) => {
      state.selectedMenu = data;
    },
    [types.SELECTEDSIDEBAR]: (state, data) => {
      state.selectedSidebar = data;
    },
    [types.SELECTTABS]: (state, data) => {
      state.selectTabs.push(data);
    },
    [types.SELECTTABSDELETE]: (state, data) => {
      state.selectTabs = state.selectTabs.filter(tab => tab.name !== data);
    },
    [types.PRIVINFO]: (state, data) => {
      state.privinfo = data
    },
    [types.REPORTINFO]: (state, data) => {
      state.report_token = data.report_token
      state.report_base_url = data.report_base_url
    },
    [types.AIMODULE]: (state, data) => {
      state.aiModule = data
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({
    reducer(val) {
      // 需要持久化的数据
      return {
        isShowMenuList: val.isShowMenuList,
        menunew: val.menunew,
        version: val.version,
        versionurl: val.versionurl,
        version_name: val.version_name,
        usermobile: val.usermobile,
        username: val.username,
        mercid: val.mercid,
        privinfo: val.privinfo,
        token: val.token,
        shop_report_default_time: val.shop_report_default_time,
        report_token: val.report_token,
        report_base_url: val.report_base_url,
        business_model: val.business_model,
        tx_ak: val.tx_ak,
        aiModule: val.aiModule
      }
    }
	})]
})
